export default {
  title: "标题",
  springFestival: {
    modalTitle: "新春快乐！",
    modalMessage: "值此新春佳节之际，河南云螭机械设备有限公司祝您和家人身体健康、万事如意、财源广进！"
  },
  contact: {
    formTitle: "客户留言",
    formSubtitle: "如果您有任何问题或需求，请随时与我们联系，我们将尽快回复您",
    name: "姓名",
    namePlaceholder: "请输入您的姓名",
    email: "邮箱",
    emailPlaceholder: "请输入您的邮箱地址",
    phone: "电话",
    phonePlaceholder: "请输入您的联系电话",
    message: "留言内容",
    messagePlaceholder: "请输入您的留言内容",
    submit: "提交留言",
    submitting: "提交中...",
    successTitle: "留言成功",
    successMessage: "您的留言已成功提交，我们将尽快与您联系！",
    required: "此项为必填项"
  },
  nav: {
    home: "首页",
    products: "产品",
    about: "关于我们",
    story: "我们的故事"
  },
  home: {
    companyTitle: "机械设备工厂",
    companyDescription1: "中国河南云螭机械设备有限公司成立于2016年5月3日。",
    companyDescription2: "主要从事机械设备的研发、生产和销售。",
    companyDescription3: "包括隔墙板安装系列、建筑行业搅拌系列等。",
    companyDescription4: "集生产、销售、售后服务于一体，在中国同类产品中享有盛誉，并远销东南亚、西亚、中东、非洲、欧美等地区。"
  },
  product: {
    badge: "优质设备",
    title: "产品中心",
    subtitle: "探索我们的优质工业设备解决方案，精心设计，持久耐用",
    contactUs: "联系我们",
    getQuote: "获取报价",
    learnMore: "了解更多",
    ctaTitle: "需要定制方案？",
    ctaSubtitle: "我们的专家团队随时准备帮助您找到满足您特定需求的完美设备",
    whatsappMessage: "我对以下产品感兴趣：",
    customizable: "如需咨询其他规格，请联系我们！支持定制！",

    highSpeedDisperser: "高速分散机",
    highSpeedDisperserParams: "功率：22千瓦 | 尺寸：长1.9×宽0.8×高1.85米",

    mixerProductionLine: "搅拌生产线",
    mixerProductionLineParams: "主电机：11KW | 上料电机：4KW | 产能：1吨",

    chiliShearing: "辣椒剪切机",
    chiliShearingParams: "尺寸：5.05×3.33×2.5米 | 功率：8.8千瓦",

    wallPanelInstaller: "墙板安装机",
    wallPanelInstallerParams: "升降电机：1500W | 行走电机：800W | 工作电压：48V",

    portableCuttingSaw: "便携式环切割锯",
    portableCuttingSawParams: "尺寸：长94.5×宽26×高55.8厘米",

    suctionCupInstaller: "吸盘玻璃安装机",
    suctionCupInstallerParams: "升降电机：1500W | 行走电机：1200W | 工作电压：48V",

    inclinedPalletTruck: "倾斜托盘车",
    inclinedPalletTruckParams: "尺寸：长1.3×宽0.7米",

    stonePaintMixer: "真石漆搅拌机",
    stonePaintMixerParams: "主电机：7.5KW | 上料电机：4KW | 产能：1吨"
  },
  footer: {
    description: "我们拥有一支由专业人员组成的专门团队，为每一件产品设计耐用性和效率。多年来，我们对质量的承诺为我们赢得了越来越多的全球客户--从中国到海外市场。集成创新--从蓝图到成品，我们控制每一个细节。行业适用性--设计用于满足不同操作需求的机器。经过验证的可靠性--多年的满意客户证明了我们的标准。",
    products: "产品中心",
    highSpeedDisperser: "高速分散机",
    mixerProductionLine: "搅拌生产线",
    chiliShearing: "辣椒剪切机",
    wallPanelInstaller: "墙板安装机",
    portableCuttingSaw: "便携式环切割锯",
    suctionCupInstaller: "吸盘玻璃安装机",
    company: "关于我们",
    aboutUs: "公司简介",
    allProducts: "全部产品",
    contact: "联系我们",
    address: "河南省漯河市",
    rights: "版权所有",
    privacy: "隐私政策",
    terms: "使用条款"
  },
  about: {
    contactInfo: "联系方式",
    addressLabel: "地址",
    address: "河南省漯河市临颍县Y043与颖松东路交叉口东南50米",
    whatsapp: "What'sApp",
    facebook: "Facebook",
    tiktok: "抖音",
    youtube: "Youtube",
    twitter: "Twitter",
    email: "邮箱",
    companyName: "公司名称"
  },
  story: {
    title: "我们的故事",
    subtitle: "匠心无界，品质为诺",
    section1: {
      year: "2016",
      title: "初心启航",
      content: "2016 年河南的风，吹醒了云螭的初心。郭浩磊带着一群匠人，在工厂里打磨出首台墙板安装机，\"踏实做事、精益求精\" 的种子，就此在汗水里生根。"
    },
    section2: {
      year: "2016",
      title: "匠心无界",
      content: "一位新加坡商人，为寻这样的设备踏遍海外，始终无果，终经多方打听，最终找到这间厂房。当他看到机器扎实的机身，眼中迸发的狂喜，这时我们才知道在全球各地也有很多地方需要这样的设备。让云螭人忽然懂得：原来匠心无界，他们手中的心血，竟是全球渴求的光亮。"
    },
    section3: {
      year: "至今",
      title: "品质为诺",
      content: "以品质为诺，以服务为暖。新加坡客户的持续加单、主动引荐，是最动人的回馈。如今云螭仍在精进，贴合海外需求迭代产品，完善售后服务跨越山海。这份坚守，让中国智造在国际浪潮中，稳稳远航。"
    },
    values: {
      title: "我们的价值观",
      quality: "品质为诺",
      qualityDesc: "以卓越品质为承诺，精益求精，打造值得信赖的产品",
      service: "服务为暖",
      serviceDesc: "以贴心服务为温暖，跨越山海，提供完善的售后保障",
      innovation: "持续精进",
      innovationDesc: "以持续创新为动力，贴合需求，不断迭代产品与服务"
    }
  }
};